import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { BoSpinnerService, BoToastrService } from '../../shared';
import { API } from '../config/api';
import { RequestAuthoriseSupplierInvoice } from './authorise-supplier-invoice.DTO';
import { SUCCESS } from 'src/@shared/constants';
import { ErrorResponse } from '../config/common';

@Injectable()
export class AuthoriseSupplierInvoiceService {
    constructor(
        private _http: HttpClient,
        private _spinner: BoSpinnerService,
        private _toastr: BoToastrService
    ) { }
    // LAY TAT CA 
    public getAuthoriseInvoice(request: RequestAuthoriseSupplierInvoice, disableSpinner?: boolean) {
        if (!disableSpinner) {
            this._spinner.show(true);
        }
        return this._http.post(`${API.AUTHORISE_INVOICE.POST}`, request)
            .pipe(tap(() => {
                this._spinner.hide();
            }),
                catchError((err: ErrorResponse) => {
                    this._spinner.hide();
                    this._toastr.errors(err.error.errors)
                    throw err;
                })
            );
    }
    // change Authoirse to Ready to Post 
    public changeAuthoriseInvoice(model: any) {
        return this._http.post(`${API.AUTHORISE_INVOICE.POST_CHANGE_AUTHORISE}`, model)
            .pipe(
                tap(() => {
                    this._toastr.successCode(SUCCESS.CHANGE_AUTHORISE_INVOICE);
                }),
                catchError((err: ErrorResponse) => {
                    this._toastr.errors(err.error.errors);
                    throw err;
                })
            )
    }
    // post to xero 
    public postToXero(model: any) {
        return this._http.post(`${API.AUTHORISE_INVOICE.POST_TO_XERO}`, model)
            .pipe(
                tap(() => {
                    this._toastr.successCode(SUCCESS.POST_TO_XERO);
                }),
                catchError((err: ErrorResponse) => {
                    this._toastr.errors(err.error.errors);
                    throw err;
                })
            )
    }
    public viewPDF(id:string){
        return this._http.get(`${API.AUTHORISE_INVOICE.PDF_VIEW(id)}`, {responseType: 'text'});
    }

    public printHardCopy(subcontractorInvoiceID: string){
        let objModel = {
            subcontractorInvoiceID: subcontractorInvoiceID
        }
        return this._http.post(`${API.AUTHORISE_INVOICE.PRINT_HARD_COPY}`, objModel, { responseType: "blob" });
    }


}
